import React from "react";
import PropTypes from "prop-types";

// react component for creating dynamic tables
// @material-ui/core components
// @material-ui/icons
import Review from "components/RestaurantDetails/RestaurantReview.js";

export default function RestaurantReviews(props) {
  const restaurant = props.restaurant;

  const getReviews = reviews => {
    const restaurant = props.restaurant;
    const attributes = props.attributes;
    const displayedReviews = reviews.map((el, index) => {
      // console.log("feoinwinofweinofweniowfeoin", el);
      if (el.userId && el.userId.userDataId) {
        return (
          <div
            // className="grid-item"
            key={`${restaurant.name}-reviews-${index.toString()}`}
            // style={{ width: '100%', float: 'left' }}
            className="review-container"
          >
            <Review
              attributes={attributes}
              review={el}
              defaultCategory={restaurant.categories[0]._id}
            />
          </div>
        );
      }
      return null;
    });
    return displayedReviews;
  };
  // console.log("PORCA PALETTAAAA");
  return (
    <div>
      {restaurant.reviews && restaurant.reviews.length > 0 ? (
        <div>
          <div
            style={{ width: "100%", display: "inline-block" }}
            id="restaurant-reviews-number-and-title"
          >
            <div
              style={{
                width: "100%",
                display: "inline-block",
                marginBottom: "30px",
                marginTop: "40px"
              }}
            >
              <div className="restaurant-details-reviews-count">
                {restaurant.reviews.length > 0 &&
                restaurant.reviewNumber &&
                restaurant.reviewNumber > 0 ? (
                  <div>
                    <span style={{ fontSize: "21px" }}>
                      {restaurant.pescatoriReviewNumber}{" "}
                    </span>
                    <span>
                      {restaurant.pescatoriReviewNumber > 1
                        ? "recensioni per "
                        : "recensione per "}
                      {restaurant.name}
                    </span>
                  </div>
                ) : (
                  <div>Non ci sono ancora recensioni</div>
                )}
              </div>
            </div>
            {getReviews(props.restaurant.reviews)}
          </div>
        </div>
      ) : null}
    </div>
  );
}

RestaurantReviews.propTypes = {
  restaurant: PropTypes.object.isRequired,
  attributes: PropTypes.object
};
RestaurantReviews.defaultProps = {
  attributes: {}
};
